
// @ts-nocheck

import { Vue, Options } from 'vue-class-component'
import { setupFactory } from '@/http/setup'
import roleAccessManager from '@/utils/role-access-manager'

  @Options({
    data () {
      return {
        links: [
          {
            id: 0,
            text: 'Dashboard',
            page: '/'
          },
          {
            id: 1,
            text: 'Rekap',
            page: '/recap'
          },
          {
            id: 2,
            text: 'Master Tagihan',
            page: '/bill'
          },
          {
            id: 3,
            text: 'Tagihan Siswa',
            page: '/bill/user'
          },
          {
            id: 4,
            text: 'Pembayaran',
            page: '/payment'
          }]
      }
    },
    computed: {
      filteredLinks() {
        return this.links.filter((link) => {
          return roleAccessManager.canRead(link.page)
        })
      }
    },
    async created () {
      Promise.resolve(setupFactory.getFeatureConfigs({ feature_configs: ['spp_show_US_import_VA'] })).then(
        (res) => {
          if ('spp_show_US_import_VA' in res.data.feature_configs && res.data.feature_configs.spp_show_US_import_VA && res.data.feature_configs.spp_show_US_import_VA == 'true') {
            this.links.push(
              {
                id: 5,
                text: 'Impor VA',
                page: '/va-import'
              }
            )
          }
        }
      )

      // check if in iframe
      if (window.self === window.top) {
        this.links.push(
          {
            id: 6,
            text: 'Konfigurasi',
            page: '/configs'
          }
        )
        // make cheat panel only available if cheatToken is available in local storage
        if (localStorage.getItem('cheatToken')) {
          this.links.push(
            {
              id: 7,
              text: 'Cheat Panel',
              page: '/cheats'
            }
          )
        }
      }
    }
  })

export default class Navbar extends Vue {}
